module.exports = __webpack_public_path__ + "img/35.61a0f524.jpg";